import React from 'react'
import Table from 'react-bootstrap/Table'
import TableLoading from 'shared/tables/table-loading'
import TableFooter from 'shared/tables/table-footer'
import moment from 'moment'

function PendingWorkflowTable({
  params,
  setParams,
  isLoading,
  isSuccess,
  data
}) {
  return (
    <>
      <Table className="border bg-white border-light my-4" responsive>
        <thead>
          <tr>
            <th>Key</th>
            <th>Approver</th>
            <th>Approval Type</th>
            <th>Time in Queue</th>
            <th>Entered Queue On</th>
            <th>Hold</th>
          </tr>
        </thead>
        {isLoading && <TableLoading columns={6} />}
        {isSuccess && data.data.length === 0 && (
          <tr>
            <td colSpan={6}>
              <div className="d-flex justify-content-center">
                <h5>No pending workflows found</h5>
              </div>
            </td>
          </tr>
        )}
        {isSuccess && data.data.length > 0 && (
          <tbody>
            {data.data.map((w, i) => (
              <tr key={`${w.key_value}-${w.approver_external_id}-${i}`}>
                <td>{w.key_value}</td>
                <td>{w.approver_name}</td>
                <td>{w.approval_type}</td>
                <td>{w.entered_at ? w.time_in_queue_in_words : ''}</td>
                <td className="text-muted fw-light">
                  {w.entered_at &&
                    moment(w.entered_at, 'YYYY-MM-DD').format('L')}
                </td>
                <td className="text-muted fw-light">
                  {w.pending_hold_at
                    ? moment(w.pending_hold_at, 'YYYY-MM-DD').format('L')
                    : ''}
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </Table>
      {isSuccess && (
        <TableFooter meta={data.meta} params={params} setParams={setParams} />
      )}
    </>
  )
}

export default PendingWorkflowTable
